<!-- USATO SIA DA REVIEW SIA DA DETAIL -->
<template>
    <div class="review-service-highlight">
        <div class="left">
            <div class="review-service-highlight--occupancy" v-if="adults | children.length">
                <div v-if="adults">
                    {{ adults }} <div v-html="(adults !== 1 ? 'Adulti' : 'Adulto')"></div>
                </div>
                <div v-if="children.length">
                    , {{ children.length }} <div v-html="(children.length !== 1 ? 'Bambini' : 'Bambino')"></div>
                    ({{ this.children.join(", ") }} {{ (this.children[this.children.length -1] === 1)? 'anno' : 'anni' }})
                </div>
            </div>
            <div class="review-service-highlight--dates" v-if="departure_date && (departure_date.length | return_date.length)">
                <div v-if="departure_date">
                    dal {{ parse_flight_offers_date(departure_date).day }}
                </div>
                <div v-if="return_date">
                    &nbsp;al {{ parse_flight_offers_date(return_date).day}}
                </div>
            </div>
        </div>
        <div class="review-service-highlight--price" v-if="price && price > 0">
            € {{ price }}
        </div>
    </div>
</template>

<script>
    import { parse_flight_offers_date } from '@/utilities'
    export default {
        name: 'review-service-highlight',
        components: {
        },
        props:
        {
            children: {
                type: Array,
                default: () => { return [] },
            },
            adults: {
                type: Number,
                default: 0,
            },
            price: {
                type: String,
                default: '',
            },
            departure_date: {
                type: String,
                default: '',
            },
            return_date: {
                type: String,
                default: '',
            },
        },
        created()
        {
            this.parse_flight_offers_date = parse_flight_offers_date
        },
        data() {
            return {
            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{
        },
    }
</script>

<style lang="scss">
    .review-service-highlight
    {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .left
        {
            display:flex;
            flex-wrap: wrap;
            align-items: center;
        }
        &--occupancy,
        &--dates
        {
            *
            {
                display:inline-block;
            }
            margin-right: 1rem;
            color:$white;
            background:$green;
            font-weight: 700;
            padding:$grid-gutter-width/4 $grid-gutter-width/2;
            font-size: 14px;
            @include media-breakpoint-up(md)
            {
                font-size: 16px;
            }
        }
        &--price
        {
            font-weight: bold;
            color:$green;
            font-size: 24px;
            @include media-breakpoint-up(md)
            {
                font-size: 32px;
            }
        }
    }
</style>